import { Fragment, useEffect, useState } from "react";

import moment from "moment";
import NumberFormat from "react-number-format";

const idLocale = require("moment/locale/id");
moment.updateLocale("id", idLocale);

interface trxPrintDataType {
	merchantName: string;
	productCode: string;
	productName: string;
	destination: string;
	sellingPrice: number;
	sellingAdmin: number;
	print: Array<{
		label: string;
		value: string;
	}>;
	feePpob: number;
	token: string;
	sn: string;
	createdAt: string;
	footer_text?: string;
}

interface PlnContentPropsType {
	printData: trxPrintDataType;
	printSize: string;
}

const PlnContent: React.FC<PlnContentPropsType> = ({
	printData,
	printSize,
}): JSX.Element => {
	const { destination, sellingPrice, sellingAdmin, print, sn, createdAt } =
		printData;

	let printSetup: any = {
		A4: {
			printTextSize: "text-xs",
			printWhiteSpace: "w-36 pr-4",
		},
		"80mm": {
			printTextSize: "text-xs",
			printWhiteSpace: "w-32 pr-4",
			printMargin: "mx-1.5 -mt-1.5",
		},
		"58mm": {
			printTextSize: "text-2xs",
			printWhiteSpace: "w-28 pr-4",
			printMargin: "mx-1.5 -mt-1.5",
			printMarginCustomeStruct: "mx-1.5 mt-0.5",
		},
	};

	let plnPrint: any = {};

	if (print.length) {
		print.forEach(({ label, value }) => {
			plnPrint[label] = value;
		});
	}

	const {
		Daya: daya,
		Jenis: type,
		Nama: name,
		Periode: periode,
		Ref: ref,
		StanAwal: firstStan,
		StandAkhir: lastStan,
		Tagihan: invoice,
	} = plnPrint;

	return (
		<div className="flex justify-center">
			<div>
				<div className="flex gap-16 mb-1 px-2">
					<div>
						{/* CUST NAME */}
						<div
							className={`${
								printSetup[printSize]
									? printSetup[printSize].printMargin
									: printSetup[printSize].printMarginCustomeStruct
							} flex items-center text-left`}>
							<div
								className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										NAMA
									</span>
								</div>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										:
									</span>
								</div>
							</div>
							<div className="flex-1 leading-3">
								<span className={`${printSetup[printSize].printTextSize}`}>
									{name}
								</span>
							</div>
						</div>

						{/* CUST ID */}
						<div
							className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
							<div
								className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										ID PELANGGAN
									</span>
								</div>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										:
									</span>
								</div>
							</div>
							<div className="flex-1">
								<span className={`${printSetup[printSize].printTextSize}`}>
									{destination}
								</span>
							</div>
						</div>

						{/* INVOICE */}
						<div
							className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
							<div
								className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										TAGIHAN
									</span>
								</div>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										:
									</span>
								</div>
							</div>
							<div className="flex-1">
								<NumberFormat
									value={sellingPrice}
									className={`${`${printSetup[printSize].printTextSize}`}`}
									displayType={"text"}
									thousandSeparator={"."}
									decimalSeparator={","}
									prefix={"Rp "}
								/>
							</div>
						</div>

						{/* DAYA */}
						<div
							className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
							<div
								className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										DAYA
									</span>
								</div>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										:
									</span>
								</div>
							</div>
							<div className="flex-1">
								<span className={`${printSetup[printSize].printTextSize}`}>
									{plnPrint["Jenis Daya"]}
								</span>
							</div>
						</div>

						{/* TYPE */}
						{/* <div className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
              <div className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
                <div>
                  <span className={`${printSetup[printSize].printTextSize}`}>JENIS</span>
                </div>
                <div>
                  <span className={`${printSetup[printSize].printTextSize}`}>:</span>
                </div>
              </div>
              <div className="flex-1">
                <span className={`${printSetup[printSize].printTextSize}`}>{type}</span>
              </div>
            </div> */}

						{printSize === "58mm" || printSize === "80mm" ? (
							<Fragment>
								{/* WHEN THERE IS A PRINT FIELD THEN SHOW THE LABEL */}
								{print.length ? (
									<Fragment>
										{/* FIRST STAN */}
										<div
											className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
											<div
												className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
												<div>
													<span
														className={`${printSetup[printSize].printTextSize}`}>
														STAND METER
													</span>
												</div>
												<div>
													<span
														className={`${printSetup[printSize].printTextSize}`}>
														:
													</span>
												</div>
											</div>
											<div className="flex-1">
												<span
													className={`${printSetup[printSize].printTextSize}`}>
													{plnPrint["Stand Meter"]}
												</span>
											</div>
										</div>

										{/* LAST STAN */}
										{/* <div className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
                      <div className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
                        <div>
                          <span className={`${printSetup[printSize].printTextSize}`}>STANAKHIR</span>
                        </div>
                        <div>
                          <span className={`${printSetup[printSize].printTextSize}`}>:</span>
                        </div>
                      </div>
                      <div className="flex-1">
                        <span className={`${printSetup[printSize].printTextSize}`}>{lastStan}</span>
                      </div>
                    </div> */}

										{/* PERIODE */}
										<div
											className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
											<div
												className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
												<div>
													<span
														className={`${printSetup[printSize].printTextSize}`}>
														PERIODE
													</span>
												</div>
												<div>
													<span
														className={`${printSetup[printSize].printTextSize}`}>
														:
													</span>
												</div>
											</div>
											<div className="flex-1">
												<span
													className={`${printSetup[printSize].printTextSize}`}>
													{periode}
												</span>
											</div>
										</div>

										{/* REF */}
										<div
											className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
											<div
												className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
												<div>
													<span
														className={`${printSetup[printSize].printTextSize}`}>
														REF
													</span>
												</div>
												<div>
													<span
														className={`${printSetup[printSize].printTextSize}`}>
														:
													</span>
												</div>
											</div>
											<div className="flex-1">
												<span
													className={`${printSetup[printSize].printTextSize}`}>
													{ref}
												</span>
											</div>
										</div>
									</Fragment>
								) : (
									<div
										className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
										<div
											className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
											<div>
												<span
													className={`${printSetup[printSize].printTextSize}`}>
													SN
												</span>
											</div>
											<div>
												<span
													className={`${printSetup[printSize].printTextSize}`}>
													:
												</span>
											</div>
										</div>
										<div className="flex-1">
											<span
												className={`${printSetup[printSize].printTextSize}`}>
												{sn}
											</span>
										</div>
									</div>
								)}
							</Fragment>
						) : (
							""
						)}
					</div>

					{printSize === "A4" && (
						<div>
							{/* DATA TIME */}
							<div
								className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
								<div
									className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
									<div>
										<span className={`${printSetup[printSize].printTextSize}`}>
											TANGGAL
										</span>
									</div>
									<div>
										<span className={`${printSetup[printSize].printTextSize}`}>
											:
										</span>
									</div>
								</div>
								<div className="flex-1">
									<span className={`${printSetup[printSize].printTextSize}`}>
										{moment.utc(createdAt).format("DD MMMM YYYY HH:mm:ss")}
									</span>
								</div>
							</div>

							{/* FIRST STAN */}
							<div
								className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
								<div
									className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
									<div>
										<span className={`${printSetup[printSize].printTextSize}`}>
											STAND METER
										</span>
									</div>
									<div>
										<span className={`${printSetup[printSize].printTextSize}`}>
											:
										</span>
									</div>
								</div>
								<div className="flex-1">
									<span className={`${printSetup[printSize].printTextSize}`}>
										{plnPrint["Stand Meter"]}
									</span>
								</div>
							</div>

							{/* LAST STAN */}
							{/* <div className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
                <div className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
                  <div>
                    <span className={`${printSetup[printSize].printTextSize}`}>STANAKHIR</span>
                  </div>
                  <div>
                    <span className={`${printSetup[printSize].printTextSize}`}>:</span>
                  </div>
                </div>
                <div className="flex-1">
                  <span className={`${printSetup[printSize].printTextSize}`}>{lastStan}</span>
                </div>
              </div> */}

							{/* PERIODE */}
							<div
								className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
								<div
									className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
									<div>
										<span className={`${printSetup[printSize].printTextSize}`}>
											PERIODE
										</span>
									</div>
									<div>
										<span className={`${printSetup[printSize].printTextSize}`}>
											:
										</span>
									</div>
								</div>
								<div className="flex-1">
									<span className={`${printSetup[printSize].printTextSize}`}>
										{periode}
									</span>
								</div>
							</div>

							{/* REF */}
							<div
								className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
								<div
									className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
									<div>
										<span className={`${printSetup[printSize].printTextSize}`}>
											REF
										</span>
									</div>
									<div>
										<span className={`${printSetup[printSize].printTextSize}`}>
											:
										</span>
									</div>
								</div>
								<div className="flex-1">
									<span className={`${printSetup[printSize].printTextSize}`}>
										{ref}
									</span>
								</div>
							</div>
						</div>
					)}
				</div>

				{printSize === "58mm" || printSize === "80mm" ? (
					<Fragment>
						{/* TOTAL PRICE */}
						<div
							className={`${printSetup[printSize].printMargin} flex justify-between items-center text-left px-2`}>
							<div
								className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										ADMIN
									</span>
								</div>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										:
									</span>
								</div>
							</div>
							<div className="flex-1">
								<NumberFormat
									value={sellingAdmin}
									className={`${`${printSetup[printSize].printTextSize}`} font-semibold`}
									displayType={"text"}
									thousandSeparator={"."}
									decimalSeparator={","}
									prefix={"Rp "}
								/>
							</div>
						</div>

						{/* TOTAL PRICE */}
						<div
							className={`${printSetup[printSize].printMargin} flex justify-between items-center text-left mb-1 px-2`}>
							<div
								className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										TOTAL
									</span>
								</div>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										:
									</span>
								</div>
							</div>
							<div className="flex-1">
								<NumberFormat
									value={sellingPrice + sellingAdmin}
									className={`${`${printSetup[printSize].printTextSize}`} font-semibold`}
									displayType={"text"}
									thousandSeparator={"."}
									decimalSeparator={","}
									prefix={"Rp "}
								/>
							</div>
						</div>
						<div className="px-2 mt-2.5 leading-3">
							<span
								className={`${`${printSetup[printSize].printTextSize}`} font-bold`}>
								STRUK INI ADALAH BUKTI PEMBAYARAN YANG SAH
							</span>
						</div>
						<div className="px-2 mt-1 leading-3">
							<span className={`${printSetup[printSize].printTextSize}`}>
								Tersedia juga Pulsa, Game, Produk Pascabayar dan Produk Lainnya
							</span>
						</div>
					</Fragment>
				) : (
					<Fragment>
						{/* TOTAL PRICE */}
						<div
							className={`${printSetup[printSize].printMargin} flex justify-between items-center text-left px-2`}>
							<div
								className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										ADMIN
									</span>
								</div>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										:
									</span>
								</div>
							</div>
							<div className="flex-1">
								<NumberFormat
									value={sellingAdmin}
									className={`${`${printSetup[printSize].printTextSize}`} font-semibold`}
									displayType={"text"}
									thousandSeparator={"."}
									decimalSeparator={","}
									prefix={"Rp "}
								/>
							</div>
						</div>
						{/* TOTAL PRICE */}
						<div
							className={`${printSetup[printSize].printMargin} flex justify-between items-center text-left mb-1 px-2`}>
							<div
								className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										TOTAL
									</span>
								</div>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										:
									</span>
								</div>
							</div>
							<div className="flex-1">
								<NumberFormat
									// value={parseInt(invoice?.replace(new RegExp('RP', 'gi'), '')) + sellingAdmin}
									value={sellingPrice + sellingAdmin}
									className={`${`${printSetup[printSize].printTextSize}`} font-semibold`}
									displayType={"text"}
									thousandSeparator={"."}
									decimalSeparator={","}
									prefix={"Rp "}
								/>
							</div>
						</div>
						<div className="px-2 mt-5 leading-3">
							<span
								className={`${`${printSetup[printSize].printTextSize}`} font-bold`}>
								STRUK INI ADALAH BUKTI PEMBAYARAN YANG SAH
							</span>
						</div>
						<div className="px-2 mt-2 leading-3">
							<span className={`${printSetup[printSize].printTextSize}`}>
								Tersedia juga Pulsa, Game, Produk Pascabayar dan Produk Lainnya
							</span>
						</div>
					</Fragment>
				)}
			</div>
		</div>
	);
};

interface SpeedyContentPropsType {
	printData: trxPrintDataType;
	printSize: string;
}

const SpeedyContent: React.FC<SpeedyContentPropsType> = ({
	printData,
	printSize,
}): JSX.Element => {
	const { destination, sellingPrice, sellingAdmin, print, sn, createdAt } =
		printData;

	let printSetup: any = {
		A4: {
			printTextSize: "text-xs",
			printWhiteSpace: "w-36 pr-4",
		},
		"80mm": {
			printTextSize: "text-xs",
			printWhiteSpace: "w-32 pr-4",
			printMargin: "mx-1.5 -mt-1.5",
		},
		"58mm": {
			printTextSize: "text-2xs",
			printWhiteSpace: "w-28 pr-4",
			printMargin: "mx-1.5 -mt-1.5",
			printMarginCustomeStruct: "mx-1.5 mt-0.5",
		},
	};

	let speedyPrint: any = {};

	if (print.length) {
		print.forEach(({ label, value }) => {
			speedyPrint[label] = value;
		});
	}

	const {
		Nama: name,
		Periode: periode,
		Reff: ref,
		Tagihan: invoice,
	} = speedyPrint;

	return (
		<div className="flex justify-center">
			<div>
				<div className="flex gap-16 mb-1 px-2">
					<div>
						{/* CUST NAME */}
						<div
							className={`${
								printSetup[printSize]
									? printSetup[printSize].printMargin
									: printSetup[printSize].printMarginCustomeStruct
							} flex items-center text-left`}>
							<div
								className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										NAMA
									</span>
								</div>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										:
									</span>
								</div>
							</div>
							<div className="flex-1 leading-3">
								<span className={`${printSetup[printSize].printTextSize}`}>
									{name}
								</span>
							</div>
						</div>

						{/* CUST ID */}
						<div
							className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
							<div
								className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										ID PELANGGAN
									</span>
								</div>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										:
									</span>
								</div>
							</div>
							<div className="flex-1">
								<span className={`${printSetup[printSize].printTextSize}`}>
									{destination}
								</span>
							</div>
						</div>

						{/* INVOICE */}
						<div
							className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
							<div
								className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										TAGIHAN
									</span>
								</div>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										:
									</span>
								</div>
							</div>
							<div className="flex-1">
								<NumberFormat
									value={sellingPrice}
									className={`${`${printSetup[printSize].printTextSize}`}`}
									displayType={"text"}
									thousandSeparator={"."}
									decimalSeparator={","}
									prefix={"Rp "}
								/>
							</div>
						</div>

						{printSize === "58mm" || printSize === "80mm" ? (
							<Fragment>
								{/* WHEN THERE IS A PRINT FIELD THEN SHOW THE LABEL */}
								{print.length ? (
									<Fragment>
										{/* PERIODE */}
										<div
											className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
											<div
												className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
												<div>
													<span
														className={`${printSetup[printSize].printTextSize}`}>
														PERIODE
													</span>
												</div>
												<div>
													<span
														className={`${printSetup[printSize].printTextSize}`}>
														:
													</span>
												</div>
											</div>
											<div className="flex-1">
												<span
													className={`${printSetup[printSize].printTextSize}`}>
													{periode}
												</span>
											</div>
										</div>

										{/* REF */}
										<div
											className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
											<div
												className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
												<div>
													<span
														className={`${printSetup[printSize].printTextSize}`}>
														REF
													</span>
												</div>
												<div>
													<span
														className={`${printSetup[printSize].printTextSize}`}>
														:
													</span>
												</div>
											</div>
											<div className="flex-1">
												<span
													className={`${printSetup[printSize].printTextSize}`}>
													{ref}
												</span>
											</div>
										</div>
									</Fragment>
								) : (
									<div
										className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
										<div
											className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
											<div>
												<span
													className={`${printSetup[printSize].printTextSize}`}>
													SN
												</span>
											</div>
											<div>
												<span
													className={`${printSetup[printSize].printTextSize}`}>
													:
												</span>
											</div>
										</div>
										<div className="flex-1">
											<span
												className={`${printSetup[printSize].printTextSize}`}>
												{sn}
											</span>
										</div>
									</div>
								)}
							</Fragment>
						) : (
							""
						)}
					</div>

					{printSize === "A4" && (
						<div>
							{/* DATA TIME */}
							<div
								className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
								<div
									className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
									<div>
										<span className={`${printSetup[printSize].printTextSize}`}>
											TANGGAL
										</span>
									</div>
									<div>
										<span className={`${printSetup[printSize].printTextSize}`}>
											:
										</span>
									</div>
								</div>
								<div className="flex-1">
									<span className={`${printSetup[printSize].printTextSize}`}>
										{moment.utc(createdAt).format("DD MMMM YYYY HH:mm:ss")}
									</span>
								</div>
							</div>

							{/* PERIODE */}
							<div
								className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
								<div
									className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
									<div>
										<span className={`${printSetup[printSize].printTextSize}`}>
											PERIODE
										</span>
									</div>
									<div>
										<span className={`${printSetup[printSize].printTextSize}`}>
											:
										</span>
									</div>
								</div>
								<div className="flex-1">
									<span className={`${printSetup[printSize].printTextSize}`}>
										{periode.replace(new RegExp("PERIODE:", "gi"), "")}
									</span>
								</div>
							</div>

							{/* REF */}
							<div
								className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
								<div
									className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
									<div>
										<span className={`${printSetup[printSize].printTextSize}`}>
											REF
										</span>
									</div>
									<div>
										<span className={`${printSetup[printSize].printTextSize}`}>
											:
										</span>
									</div>
								</div>
								<div className="flex-1">
									<span className={`${printSetup[printSize].printTextSize}`}>
										{ref}
									</span>
								</div>
							</div>
						</div>
					)}
				</div>

				{printSize === "58mm" || printSize === "80mm" ? (
					<Fragment>
						{/* TOTAL PRICE */}
						<div
							className={`${printSetup[printSize].printMargin} flex justify-between items-center text-left px-2`}>
							<div
								className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										ADMIN
									</span>
								</div>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										:
									</span>
								</div>
							</div>
							<div className="flex-1">
								<NumberFormat
									value={sellingAdmin}
									className={`${`${printSetup[printSize].printTextSize}`} font-semibold`}
									displayType={"text"}
									thousandSeparator={"."}
									decimalSeparator={","}
									prefix={"Rp "}
								/>
							</div>
						</div>

						{/* TOTAL PRICE */}
						<div
							className={`${printSetup[printSize].printMargin} flex justify-between items-center text-left mb-1 px-2`}>
							<div
								className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										TOTAL
									</span>
								</div>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										:
									</span>
								</div>
							</div>
							<div className="flex-1">
								<NumberFormat
									value={sellingPrice + sellingAdmin}
									className={`${`${printSetup[printSize].printTextSize}`} font-semibold`}
									displayType={"text"}
									thousandSeparator={"."}
									decimalSeparator={","}
									prefix={"Rp "}
								/>
							</div>
						</div>
						<div className="px-2 mt-2.5 leading-3">
							<span
								className={`${`${printSetup[printSize].printTextSize}`} font-bold`}>
								STRUK INI ADALAH BUKTI PEMBAYARAN YANG SAH
							</span>
						</div>
						<div className="px-2 mt-1 leading-3">
							<span className={`${printSetup[printSize].printTextSize}`}>
								Tersedia juga Pulsa, Game, Produk Pascabayar dan Produk Lainnya
							</span>
						</div>
					</Fragment>
				) : (
					<Fragment>
						{/* TOTAL PRICE */}
						<div
							className={`${printSetup[printSize].printMargin} flex justify-between items-center text-left px-2`}>
							<div
								className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										ADMIN
									</span>
								</div>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										:
									</span>
								</div>
							</div>
							<div className="flex-1">
								<NumberFormat
									value={sellingAdmin}
									className={`${`${printSetup[printSize].printTextSize}`} font-semibold`}
									displayType={"text"}
									thousandSeparator={"."}
									decimalSeparator={","}
									prefix={"Rp "}
								/>
							</div>
						</div>
						{/* TOTAL PRICE */}
						<div
							className={`${printSetup[printSize].printMargin} flex justify-between items-center text-left mb-1 px-2`}>
							<div
								className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										TOTAL
									</span>
								</div>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										:
									</span>
								</div>
							</div>
							<div className="flex-1">
								<NumberFormat
									value={sellingPrice + sellingAdmin}
									className={`${`${printSetup[printSize].printTextSize}`} font-semibold`}
									displayType={"text"}
									thousandSeparator={"."}
									decimalSeparator={","}
									prefix={"Rp "}
								/>
							</div>
						</div>
						<div className="px-2 mt-5 leading-3">
							<span
								className={`${`${printSetup[printSize].printTextSize}`} font-bold`}>
								STRUK INI ADALAH BUKTI PEMBAYARAN YANG SAH
							</span>
						</div>
						<div className="px-2 mt-2 leading-3">
							<span className={`${printSetup[printSize].printTextSize}`}>
								Tersedia juga Pulsa, Game, Produk Pascabayar dan Produk Lainnya
							</span>
						</div>
					</Fragment>
				)}
			</div>
		</div>
	);
};

interface BpjsContentPropsType {
	printData: trxPrintDataType;
	printSize: string;
}

const BpjsContent: React.FC<BpjsContentPropsType> = ({
	printData,
	printSize,
}): JSX.Element => {
	const { destination, sellingPrice, sellingAdmin, print, sn, createdAt } =
		printData;

	let printSetup: any = {
		A4: {
			printTextSize: "text-xs",
			printWhiteSpace: "w-36 pr-4",
		},
		"80mm": {
			printTextSize: "text-xs",
			printWhiteSpace: "w-32 pr-4",
			printMargin: "mx-1.5 -mt-1.5",
		},
		"58mm": {
			printTextSize: "text-2xs",
			printWhiteSpace: "w-28 pr-4",
			printMargin: "mx-1.5 -mt-1.5",
			printMarginCustomeStruct: "mx-1.5 mt-0.5",
		},
	};

	let speedyPrint: any = {};

	if (print.length) {
		print.forEach(({ label, value }) => {
			speedyPrint[label] = value;
		});
	}

	const {
		Nama: name,
		Periode: periode,
		Ref: ref,
		Tagihan: invoice,
	} = speedyPrint;

	return (
		<div className="flex justify-center">
			<div>
				<div className="flex gap-16 mb-1 px-2">
					<div>
						{/* CUST NAME */}
						<div
							className={`${
								printSetup[printSize]
									? printSetup[printSize].printMargin
									: printSetup[printSize].printMarginCustomeStruct
							} flex items-center text-left`}>
							<div
								className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										NAMA
									</span>
								</div>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										:
									</span>
								</div>
							</div>
							<div className="flex-1 leading-3">
								<span className={`${printSetup[printSize].printTextSize}`}>
									{name}
								</span>
							</div>
						</div>

						{/* CUST ID */}
						<div
							className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
							<div
								className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										ID PELANGGAN
									</span>
								</div>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										:
									</span>
								</div>
							</div>
							<div className="flex-1">
								<span className={`${printSetup[printSize].printTextSize}`}>
									{destination}
								</span>
							</div>
						</div>

						{/* INVOICE */}
						<div
							className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
							<div
								className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										TAGIHAN
									</span>
								</div>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										:
									</span>
								</div>
							</div>
							<div className="flex-1">
								<NumberFormat
									value={sellingPrice}
									className={`${`${printSetup[printSize].printTextSize}`}`}
									displayType={"text"}
									thousandSeparator={"."}
									decimalSeparator={","}
									prefix={"Rp "}
								/>
							</div>
						</div>

						{printSize === "58mm" || printSize === "80mm" ? (
							<Fragment>
								{/* WHEN THERE IS A PRINT FIELD THEN SHOW THE LABEL */}
								{print.length ? (
									<Fragment>
										{/* PERIODE */}
										<div
											className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
											<div
												className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
												<div>
													<span
														className={`${printSetup[printSize].printTextSize}`}>
														PREMI
													</span>
												</div>
												<div>
													<span
														className={`${printSetup[printSize].printTextSize}`}>
														:
													</span>
												</div>
											</div>
											<div className="flex-1">
												<span
													className={`${printSetup[printSize].printTextSize}`}>
													{speedyPrint["Premi"]}
												</span>
											</div>
										</div>

										{/* REF */}
										<div
											className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
											<div
												className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
												<div>
													<span
														className={`${printSetup[printSize].printTextSize}`}>
														REF
													</span>
												</div>
												<div>
													<span
														className={`${printSetup[printSize].printTextSize}`}>
														:
													</span>
												</div>
											</div>
											<div className="flex-1">
												<span
													className={`${printSetup[printSize].printTextSize}`}>
													{ref}
												</span>
											</div>
										</div>
									</Fragment>
								) : (
									<div
										className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
										<div
											className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
											<div>
												<span
													className={`${printSetup[printSize].printTextSize}`}>
													SN
												</span>
											</div>
											<div>
												<span
													className={`${printSetup[printSize].printTextSize}`}>
													:
												</span>
											</div>
										</div>
										<div className="flex-1">
											<span
												className={`${printSetup[printSize].printTextSize}`}>
												{sn}
											</span>
										</div>
									</div>
								)}
							</Fragment>
						) : (
							""
						)}
					</div>

					{printSize === "A4" && (
						<div>
							{/* DATA TIME */}
							<div
								className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
								<div
									className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
									<div>
										<span className={`${printSetup[printSize].printTextSize}`}>
											TANGGAL
										</span>
									</div>
									<div>
										<span className={`${printSetup[printSize].printTextSize}`}>
											:
										</span>
									</div>
								</div>
								<div className="flex-1">
									<span className={`${printSetup[printSize].printTextSize}`}>
										{moment.utc(createdAt).format("DD MMMM YYYY HH:mm:ss")}
									</span>
								</div>
							</div>

							{/* PERIODE */}
							<div
								className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
								<div
									className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
									<div>
										<span className={`${printSetup[printSize].printTextSize}`}>
											PREMI
										</span>
									</div>
									<div>
										<span className={`${printSetup[printSize].printTextSize}`}>
											:
										</span>
									</div>
								</div>
								<div className="flex-1">
									<span className={`${printSetup[printSize].printTextSize}`}>
										{speedyPrint["Premi"]}
									</span>
								</div>
							</div>

							{/* REF */}
							<div
								className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
								<div
									className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
									<div>
										<span className={`${printSetup[printSize].printTextSize}`}>
											REF
										</span>
									</div>
									<div>
										<span className={`${printSetup[printSize].printTextSize}`}>
											:
										</span>
									</div>
								</div>
								<div className="flex-1">
									<span className={`${printSetup[printSize].printTextSize}`}>
										{ref}
									</span>
								</div>
							</div>
						</div>
					)}
				</div>

				{printSize === "58mm" || printSize === "80mm" ? (
					<Fragment>
						{/* TOTAL PRICE */}
						<div
							className={`${printSetup[printSize].printMargin} flex justify-between items-center text-left px-2`}>
							<div
								className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										ADMIN
									</span>
								</div>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										:
									</span>
								</div>
							</div>
							<div className="flex-1">
								<NumberFormat
									value={sellingAdmin}
									className={`${`${printSetup[printSize].printTextSize}`} font-semibold`}
									displayType={"text"}
									thousandSeparator={"."}
									decimalSeparator={","}
									prefix={"Rp "}
								/>
							</div>
						</div>

						{/* TOTAL PRICE */}
						<div
							className={`${printSetup[printSize].printMargin} flex justify-between items-center text-left mb-1 px-2`}>
							<div
								className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										TOTAL
									</span>
								</div>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										:
									</span>
								</div>
							</div>
							<div className="flex-1">
								<NumberFormat
									value={sellingPrice + sellingAdmin}
									className={`${`${printSetup[printSize].printTextSize}`} font-semibold`}
									displayType={"text"}
									thousandSeparator={"."}
									decimalSeparator={","}
									prefix={"Rp "}
								/>
							</div>
						</div>

						<div className="px-2 mt-2.5 leading-3">
							<span
								className={`${`${printSetup[printSize].printTextSize}`} font-bold`}>
								STRUK INI ADALAH BUKTI PEMBAYARAN YANG SAH
							</span>
						</div>
						<div className="px-2 mt-1 leading-3">
							<span className={`${printSetup[printSize].printTextSize}`}>
								Tersedia juga Pulsa, Game, Produk Pascabayar dan Produk Lainnya
							</span>
						</div>
					</Fragment>
				) : (
					<Fragment>
						{/* TOTAL PRICE */}
						<div
							className={`${printSetup[printSize].printMargin} flex justify-between items-center text-left px-2`}>
							<div
								className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										ADMIN
									</span>
								</div>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										:
									</span>
								</div>
							</div>
							<div className="flex-1">
								<NumberFormat
									value={sellingAdmin}
									className={`${`${printSetup[printSize].printTextSize}`} font-semibold`}
									displayType={"text"}
									thousandSeparator={"."}
									decimalSeparator={","}
									prefix={"Rp "}
								/>
							</div>
						</div>

						{/* TOTAL PRICE */}
						<div
							className={`${printSetup[printSize].printMargin} flex justify-between items-center text-left mb-1 px-2`}>
							<div
								className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										TOTAL
									</span>
								</div>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										:
									</span>
								</div>
							</div>
							<div className="flex-1">
								<NumberFormat
									value={sellingPrice + sellingAdmin}
									className={`${`${printSetup[printSize].printTextSize}`} font-semibold`}
									displayType={"text"}
									thousandSeparator={"."}
									decimalSeparator={","}
									prefix={"Rp "}
								/>
							</div>
						</div>
						<div className="px-2 mt-5 leading-3">
							<span
								className={`${`${printSetup[printSize].printTextSize}`} font-bold`}>
								STRUK INI ADALAH BUKTI PEMBAYARAN YANG SAH
							</span>
						</div>
						<div className="px-2 mt-2 leading-3">
							<span className={`${printSetup[printSize].printTextSize}`}>
								Tersedia juga Pulsa, Game, Produk Pascabayar dan Produk Lainnya
							</span>
						</div>
					</Fragment>
				)}
			</div>
		</div>
	);
};

interface DefaultContentPropsType {
	printData: trxPrintDataType;
	printSize: string;
}

const DefaultContent: React.FC<DefaultContentPropsType> = ({
	printData,
	printSize,
}): JSX.Element => {
	let [isPostpaidState, setIsPostpaidState] = useState<boolean>(false);

	const {
		destination,
		feePpob,
		productName,
		sellingPrice,
		sellingAdmin,
		print,
		sn,
		createdAt,
		footer_text,
	} = printData;

	let printSetup: any = {
		A4: {
			printTextSize: "text-xs",
			printWhiteSpace: feePpob > 0 ? "w-36 pr-4" : "w-28 pr-4",
			printMargin: "mx-3",
			printPadding:
				printSize === "A4" && print.length >= 4
					? "px-[23rem]"
					: print.length >= 8
					? "px-64"
					: "",
			printGridTemplate:
				printSize === "A4" && print.length >= 4
					? "grid grid-flow-col grid-cols-4 grid-rows-4"
					: print.length >= 8
					? "grid grid-flow-col grid-cols-2 grid-rows-6"
					: "",
		},
		"80mm": {
			printTextSize: "text-xs",
			printWhiteSpace: feePpob > 0 ? "w-36 pr-4" : "w-24 pr-4",
			printMargin: "mx-1.5 -mt-1.5",
			printPadding: "px-2",
		},
		"58mm": {
			printTextSize: "text-2xs",
			printWhiteSpace: feePpob > 0 ? "w-36 pr-4" : "w-20 pr-4",
			printMargin: "mx-1.5 -mt-1.5",
			printMarginCustomeStruct: feePpob > 0 ? "" : "mx-1.5 mt-0.5",
			printPadding: "px-2",
		},
	};

	let printDataResult: any = {};

	if (print.length) {
		print.forEach(({ label, value }) => {
			printDataResult[label] = value;
		});
	}

	interface PrintDataFilterType {
		label: string;
		value: string;
	}

	let printDataFilter: Array<PrintDataFilterType> = [];
	let tagihan: number = 0;
	let tokenSn: string = "";

	if (print.length) {
		printDataFilter = print.filter(
			({ label }: { label: string }) => label !== "Token" && label !== "token"
		);
		tokenSn =
			print.find((item) => item.label === "Token" || item.label === "token")
				?.value || "";
		let valueTagihan = printDataFilter.find(
			(item) => item.label === "Tagihan"
		) || { value: 0 };
		tagihan = Number(valueTagihan.value);
	}

	if (tagihan == 0 && sellingPrice != 0) {
		tagihan = sellingPrice;
	}

	useEffect((): void => {
		if (feePpob > 0) {
			setIsPostpaidState(true);
		}
	}, []);

	return (
		<Fragment>
			<div className={`mb-1 ${printSetup[printSize].printPadding}`}>
				<div className={`${printSize === "A4" ? "flex justify-center" : ""}`}>
					<div className={`${printSetup[printSize].printGridTemplate}`}>
						{/* PRODUCT NAME */}
						<div
							className={`${
								printSetup[printSize]
									? printSetup[printSize].printMargin
									: printSetup[printSize].printMarginCustomeStruct
							} flex items-center text-left`}>
							<div
								className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										PRODUK
									</span>
								</div>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										:
									</span>
								</div>
							</div>
							<div className="flex-1 leading-3">
								<span className={`${printSetup[printSize].printTextSize}`}>
									{productName}
								</span>
							</div>
						</div>

						{/* DESTINATION */}
						<div
							className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
							<div
								className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										ID PELANGGAN
									</span>
								</div>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										:
									</span>
								</div>
							</div>
							<div className="flex-1">
								<span className={`${printSetup[printSize].printTextSize}`}>
									{destination}
								</span>
							</div>
						</div>

						{/* SELLING PRICE */}
						{/* <div className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
              <div className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
                <div>
                  <span className={`${printSetup[printSize].printTextSize}`}>HARGA</span>
                </div>
                <div>
                  <span className={`${printSetup[printSize].printTextSize}`}>:</span>
                </div>
              </div>
              <div className="flex-1">
                <NumberFormat
                  value={sellingPrice}
                  className={`${printSetup[printSize].printTextSize}`}
                  displayType={"text"}
                  thousandSeparator={"."}
                  decimalSeparator={","}
                  prefix={"Rp "}
                />
              </div>
            </div> */}

						{printSize === "A4" && (
							<Fragment>
								{/* DATA TIME */}
								<div
									className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
									<div
										className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
										<div>
											<span
												className={`${printSetup[printSize].printTextSize}`}>
												TANGGAL
											</span>
										</div>
										<div>
											<span
												className={`${printSetup[printSize].printTextSize}`}>
												:
											</span>
										</div>
									</div>
									<div className="flex-1">
										<span className={`${printSetup[printSize].printTextSize}`}>
											{moment.utc(createdAt).format("DD MMMM YYYY HH:mm:ss")}
										</span>
									</div>
								</div>
							</Fragment>
						)}

						<Fragment>
							{/* WHEN THERE IS A PRINT FIELD THEN SHOW THE LABEL */}
							{print.length ? (
								<Fragment>
									{printDataFilter.map(({ label, value }, index) => {
										let excludedLabels = [
											"No Reff",
											"Tarif",
											"Nama",
											"Alamat",
											"Periode",
											"pemakaian",
											"Stan Meter",
										];

										return (
											label != "Total" && (
												<Fragment key={index}>
													<div
														className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
														<div
															className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
															<div>
																<span
																	className={`${`${printSetup[printSize].printTextSize}`} uppercase`}>
																	{label}
																</span>
															</div>
															<div>
																<span
																	className={`${printSetup[printSize].printTextSize}`}>
																	:
																</span>
															</div>
														</div>
														<div className="flex-1">
															{label == "Nominal" ? (
																<NumberFormat
																	value={value}
																	className={`${printSetup[printSize].printTextSize}`}
																	displayType={"text"}
																	thousandSeparator={"."}
																	decimalSeparator={","}
																	prefix={"Rp "}
																/>
															) : !excludedLabels.includes(label) &&
															  Number.isInteger(parseFloat(value)) ? (
																<span
																	className={`${printSetup[printSize].printTextSize}`}>
																	<NumberFormat
																		value={value}
																		className={`${`${printSetup[printSize].printTextSize}`}`}
																		displayType={"text"}
																		thousandSeparator={"."}
																		decimalSeparator={","}
																		prefix={"Rp "}
																	/>
																</span>
															) : (
																<span
																	className={`${printSetup[printSize].printTextSize}`}>
																	{value.length > 16
																		? value
																				.replace(
																					new RegExp("NO REFERENSI :", "gi"),
																					""
																				)
																				.substring(0, 16) + "XXX"
																		: value}
																</span>
															)}
														</div>
													</div>
												</Fragment>
											)
										);
									})}
								</Fragment>
							) : (
								""
							)}
						</Fragment>

						{/* JIKA PANJANG REGEXT PRINT LEBIH DARI 6 */}
						{print.length > 6 && (
							<Fragment>
								{/* NOMINAL */}
								{sellingPrice > 0 && (
									<div
										className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
										<div
											className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
											<div>
												<span
													className={`${printSetup[printSize].printTextSize}`}>
													TAGIHAN
												</span>
											</div>
											<div>
												<span
													className={`${printSetup[printSize].printTextSize}`}>
													:
												</span>
											</div>
										</div>
										<div className="flex-1">
											<NumberFormat
												value={sellingPrice}
												className={`${printSetup[printSize].printTextSize}`}
												displayType={"text"}
												thousandSeparator={"."}
												decimalSeparator={","}
												prefix={"Rp "}
											/>
										</div>
									</div>
								)}

								{/* ADMIN */}
								{sellingAdmin > 0 && (
									<div
										className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
										<div
											className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
											<div>
												<span
													className={`${printSetup[printSize].printTextSize}`}>
													ADMIN
												</span>
											</div>
											<div>
												<span
													className={`${printSetup[printSize].printTextSize}`}>
													:
												</span>
											</div>
										</div>
										<div className="flex-1">
											<NumberFormat
												value={sellingAdmin}
												className={`${printSetup[printSize].printTextSize}`}
												displayType={"text"}
												thousandSeparator={"."}
												decimalSeparator={","}
												prefix={"Rp "}
											/>
										</div>
									</div>
								)}
							</Fragment>
						)}

						{/* WHEN THERE IS A PRINT FIELD THEN SHOW THE LABEL */}
						{!print.length && (
							<>
								<Fragment>
									<div
										className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
										<div
											className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
											<div>
												<span
													className={`${`${printSetup[printSize].printTextSize}`}`}>
													SN
												</span>
											</div>
											<div>
												<span
													className={`${printSetup[printSize].printTextSize}`}>
													:
												</span>
											</div>
										</div>
										<div className="flex-1">
											<span
												className={`${printSetup[printSize].printTextSize} break-all whitespace-normal`}
												style={{
													fontSize: "10px",
													wordBreak: "break-all",
													whiteSpace: "normal",
													display: "block",
												}}>
												{sn.length > 14 ? sn.substring(0, 14) + "XXX" : sn}
											</span>
										</div>
									</div>
								</Fragment>

								{/* <Fragment>
                  <div className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
                    <div className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
                      <div>
                        <span className={`${`${printSetup[printSize].printTextSize}`}`}>HARGA</span>
                      </div>
                      <div>
                        <span className={`${printSetup[printSize].printTextSize}`}>:</span>
                      </div>
                    </div>
                    <div className="flex-1">
                    <NumberFormat
                      value={tagihan}
                      className={`${printSetup[printSize].printTextSize}`}
                      displayType={"text"}
                      thousandSeparator={"."}
                      decimalSeparator={","}
                      prefix={"Rp "}
                    />
                    </div>
                  </div>
                </Fragment> */}

								<Fragment>
									<div
										className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
										<div
											className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
											<div>
												<span
													className={`${`${printSetup[printSize].printTextSize}`}`}>
													ADMIN
												</span>
											</div>
											<div>
												<span
													className={`${printSetup[printSize].printTextSize}`}>
													:
												</span>
											</div>
										</div>
										<div className="flex-1">
											<NumberFormat
												value={sellingAdmin}
												className={`${printSetup[printSize].printTextSize}`}
												displayType={"text"}
												thousandSeparator={"."}
												decimalSeparator={","}
												prefix={"Rp "}
											/>
										</div>
									</div>
								</Fragment>
							</>
						)}
					</div>
				</div>
			</div>

			{printSize === "58mm" || printSize === "80mm" ? (
				<Fragment>
					{/* TOTAL PRICE */}
					<div
						className={`${printSetup[printSize].printMargin} flex justify-between items-center text-left mb-1 px-2`}>
						<div
							className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
							<div>
								<span className={`${printSetup[printSize].printTextSize}`}>
									TOTAL
								</span>
							</div>
							<div>
								<span className={`${printSetup[printSize].printTextSize}`}>
									:
								</span>
							</div>
						</div>
						<div className="flex-1">
							<NumberFormat
								value={tagihan + sellingAdmin}
								className={`${`${printSetup[printSize].printTextSize}`} font-bold`}
								displayType={"text"}
								thousandSeparator={"."}
								decimalSeparator={","}
								prefix={"Rp "}
							/>
						</div>
					</div>

					{/* JIKA PRINT 55MM & 85MM MUNCULKAN SN DI BAWAH */}
					{tokenSn && (
						<div className="px-2 mt-3 leading-3">
							<div className="flex-1 border border-dotted-2xl rounded-lg border-black p-2 bg-slate-200">
								<span
									className={`${printSetup[printSize].printTextSize} font-bold`}>
									{tokenSn}
								</span>
							</div>
						</div>
					)}

					{footer_text ? (
						<div className="px-2 mt-3 leading-3">
							<span
								className={`${`${printSetup[printSize].printTextSize}`} font-bold`}>
								{footer_text}
							</span>
						</div>
					) : (
						<Fragment>
							<div className="px-2 mt-3 leading-3">
								<span
									className={`${`${printSetup[printSize].printTextSize}`} font-bold`}>
									STRUK INI ADALAH BUKTI PEMBAYARAN YANG SAH
								</span>
							</div>
							<div className="px-2 mt-1 leading-3">
								<span className={`${printSetup[printSize].printTextSize}`}>
									Tersedia juga Pulsa, Game, Produk Pascabayar dan Produk
									Lainnya
								</span>
							</div>
						</Fragment>
					)}
				</Fragment>
			) : (
				<Fragment>
					<div className={`flex justify-center mt-4`}>
						{tokenSn && (
							<div
								className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
								<div
									className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
									<div>
										<span className={`${printSetup[printSize].printTextSize}`}>
											TOKEN
										</span>
									</div>
									<div>
										<span className={`${printSetup[printSize].printTextSize}`}>
											:
										</span>
									</div>
								</div>
								<div className="flex-1">
									<span className={`${printSetup[printSize].printTextSize}`}>
										{tokenSn}
									</span>
								</div>
							</div>
						)}

						{print.length > 6 && (
							<>
								{sellingPrice > 0 && (
									<div
										className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
										<div
											className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
											<div>
												<span
													className={`${printSetup[printSize].printTextSize}`}>
													TAGIHAN
												</span>
											</div>
											<div>
												<span
													className={`${printSetup[printSize].printTextSize}`}>
													:
												</span>
											</div>
										</div>
										<div className="flex-1">
											<NumberFormat
												value={sellingPrice}
												className={`${printSetup[printSize].printTextSize}`}
												displayType={"text"}
												thousandSeparator={"."}
												decimalSeparator={","}
												prefix={"Rp "}
											/>
										</div>
									</div>
								)}

								{/* ADMIN */}
								{sellingAdmin > 0 && (
									<div
										className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
										<div
											className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
											<div>
												<span
													className={`${printSetup[printSize].printTextSize}`}>
													ADMIN
												</span>
											</div>
											<div>
												<span
													className={`${printSetup[printSize].printTextSize}`}>
													:
												</span>
											</div>
										</div>
										<div className="flex-1">
											<NumberFormat
												value={sellingAdmin}
												className={`${printSetup[printSize].printTextSize}`}
												displayType={"text"}
												thousandSeparator={"."}
												decimalSeparator={","}
												prefix={"Rp "}
											/>
										</div>
									</div>
								)}
							</>
						)}

						{/* TOTAL PRICE */}
						<div
							className={`${printSetup[printSize].printMargin} flex justify-between items-center text-center mb-1`}>
							<div
								className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										TOTAL
									</span>
								</div>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										:
									</span>
								</div>
							</div>
							<div className="flex-1">
								<NumberFormat
									value={tagihan + sellingAdmin}
									className={`${`${printSetup[printSize].printTextSize}`} font-bold`}
									displayType={"text"}
									thousandSeparator={"."}
									decimalSeparator={","}
									prefix={"Rp "}
								/>
							</div>
						</div>
					</div>

					{footer_text ? (
						<div className="px-2 mt-3 leading-3">
							<span
								className={`${`${printSetup[printSize].printTextSize}`} font-bold`}>
								{footer_text}
							</span>
						</div>
					) : (
						<Fragment>
							<div className="px-2 mt-4 leading-3">
								<span
									className={`${`${printSetup[printSize].printTextSize}`} font-bold`}>
									STRUK INI ADALAH BUKTI PEMBAYARAN YANG SAH
								</span>
							</div>
							<div className="px-2 mt-1 leading-3">
								<span className="text-xs">
									Tersedia juga Pulsa, Game, Produk Pascabayar dan Produk
									Lainnya
								</span>
							</div>
						</Fragment>
					)}
				</Fragment>
			)}
		</Fragment>
	);
};

const PDAMContent: React.FC<DefaultContentPropsType> = ({
	printData,
	printSize,
}): JSX.Element => {
	let [isPostpaidState, setIsPostpaidState] = useState<boolean>(false);

	const {
		destination,
		feePpob,
		productName,
		sellingPrice,
		sellingAdmin,
		print,
		sn,
		createdAt,
		footer_text,
	} = printData;

	let printSetup: any = {
		A4: {
			printTextSize: "text-xs",
			printWhiteSpace: feePpob > 0 ? "w-36 pr-4" : "w-28 pr-4",
			printMargin: "mx-3",
			printPadding: "px-4",
			printGridTemplate: "",
			printContainerClass: "flex justify-center",
			printSectionClass: "grid grid-cols-3 gap-2",
		},
		"80mm": {
			printTextSize: "text-xs",
			printWhiteSpace: feePpob > 0 ? "w-36 pr-4" : "w-24 pr-4",
			printMargin: "mx-1.5 -mt-1.5",
			printPadding: "px-2",
		},
		"58mm": {
			printTextSize: "text-2xs",
			printWhiteSpace: feePpob > 0 ? "w-36 pr-4" : "w-20 pr-4",
			printMargin: "mx-1.5 -mt-1.5",
			printMarginCustomeStruct: feePpob > 0 ? "" : "mx-1.5 mt-0.5",
			printPadding: "px-2",
		},
	};

	let printDataResult: any = {};

	if (print.length) {
		print.forEach(({ label, value }) => {
			printDataResult[label] = value;
		});
	}

	interface PrintDataFilterType {
		label: string;
		value: string;
	}

	let printDataFilter: Array<PrintDataFilterType> = [];
	let tagihan: number = 0;
	let tokenSn: string = "";

	if (print.length) {
		printDataFilter = print.filter(
			({ label }: { label: string }) => label !== "Token" && label !== "token"
		);
		tokenSn =
			print.find((item) => item.label === "Token" || item.label === "token")
				?.value || "";
		let valueTagihan = printDataFilter.find(
			(item) => item.label === "Tagihan"
		) || { value: 0 };
		tagihan = Number(valueTagihan.value);
	}

	if (tagihan == 0 && sellingPrice != 0) {
		tagihan = sellingPrice;
	}

	useEffect((): void => {
		if (feePpob > 0) {
			setIsPostpaidState(true);
		}
	}, []);

	return (
		<Fragment>
			<div
				className={`mb-1 ${printSetup[printSize].printPadding} ${
					printSize === "A4" ? "print-a4-content" : ""
				}`}>
				<div
					className={`${
						printSize === "A4" ? printSetup[printSize].printContainerClass : ""
					}`}>
					<div
						className={`${
							printSize === "A4"
								? printSetup[printSize].printSectionClass
								: printSetup[printSize].printGridTemplate
						}`}>
						{/* PRODUCT NAME */}
						<div
							className={`${
								printSetup[printSize]
									? printSetup[printSize].printMargin
									: printSetup[printSize].printMarginCustomeStruct
							} flex items-center text-left ${
								printSize === "A4" ? "print-a4-section" : ""
							}`}>
							<div
								className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										PRODUK
									</span>
								</div>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										:
									</span>
								</div>
							</div>
							<div className="flex-1 leading-3">
								<span className={`${printSetup[printSize].printTextSize}`}>
									{productName}
								</span>
							</div>
						</div>

						{/* DESTINATION */}
						<div
							className={`${
								printSetup[printSize].printMargin
							} flex items-center text-left ${
								printSize === "A4" ? "print-a4-section" : ""
							}`}>
							<div
								className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										ID PELANGGAN
									</span>
								</div>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										:
									</span>
								</div>
							</div>
							<div className="flex-1">
								<span className={`${printSetup[printSize].printTextSize}`}>
									{destination}
								</span>
							</div>
						</div>

						{/* SELLING PRICE */}
						{/* <div className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
              <div className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
                <div>
                  <span className={`${printSetup[printSize].printTextSize}`}>HARGA</span>
                </div>
                <div>
                  <span className={`${printSetup[printSize].printTextSize}`}>:</span>
                </div>
              </div>
              <div className="flex-1">
                <NumberFormat
                  value={sellingPrice}
                  className={`${printSetup[printSize].printTextSize}`}
                  displayType={"text"}
                  thousandSeparator={"."}
                  decimalSeparator={","}
                  prefix={"Rp "}
                />
              </div>
            </div> */}

						{printSize === "A4" && (
							<Fragment>
								{/* DATA TIME */}
								<div
									className={`${
										printSetup[printSize].printMargin
									} flex items-center text-left ${
										printSize === "A4" ? "print-a4-section" : ""
									}`}>
									<div
										className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
										<div>
											<span
												className={`${printSetup[printSize].printTextSize}`}>
												TANGGAL
											</span>
										</div>
										<div>
											<span
												className={`${printSetup[printSize].printTextSize}`}>
												:
											</span>
										</div>
									</div>
									<div className="flex-1">
										<span className={`${printSetup[printSize].printTextSize}`}>
											{moment.utc(createdAt).format("DD MMMM YYYY HH:mm:ss")}
										</span>
									</div>
								</div>
							</Fragment>
						)}

						<Fragment>
							{/* WHEN THERE IS A PRINT FIELD THEN SHOW THE LABEL */}
							{print.length ? (
								<Fragment>
									{printDataFilter.map(({ label, value }, index) => {
										let excludedLabels = [
											"No Reff",
											"Tarif",
											"Nama",
											"Alamat",
											"Periode",
											"pemakaian",
											"Stan Meter",
										];

										return (
											label != "Total" && (
												<Fragment key={index}>
													<div
														className={`${
															printSetup[printSize].printMargin
														} flex items-center text-left ${
															printSize === "A4" ? "print-a4-section" : ""
														}`}>
														<div
															className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
															<div>
																<span
																	className={`${`${printSetup[printSize].printTextSize}`} uppercase`}>
																	{label}
																</span>
															</div>
															<div>
																<span
																	className={`${printSetup[printSize].printTextSize}`}>
																	:
																</span>
															</div>
														</div>
														<div className="flex-1">
															{label == "Nominal" ? (
																<NumberFormat
																	value={value}
																	className={`${printSetup[printSize].printTextSize}`}
																	displayType={"text"}
																	thousandSeparator={"."}
																	decimalSeparator={","}
																	prefix={"Rp "}
																/>
															) : !excludedLabels.includes(label) &&
															  Number.isInteger(parseFloat(value)) ? (
																<span
																	className={`${printSetup[printSize].printTextSize}`}>
																	<NumberFormat
																		value={value}
																		className={`${`${printSetup[printSize].printTextSize}`}`}
																		displayType={"text"}
																		thousandSeparator={"."}
																		decimalSeparator={","}
																		prefix={"Rp "}
																	/>
																</span>
															) : (
																<span
																	className={`${printSetup[printSize].printTextSize}`}>
																	{value.length > 16
																		? value
																				.replace(
																					new RegExp("NO REFERENSI :", "gi"),
																					""
																				)
																				.substring(0, 16) + "XXX"
																		: value}
																</span>
															)}
														</div>
													</div>
												</Fragment>
											)
										);
									})}
								</Fragment>
							) : (
								""
							)}
						</Fragment>

						{/* JIKA PANJANG REGEXT PRINT LEBIH DARI 6 */}
						{print.length > 6 && (
							<Fragment>
								{/* NOMINAL */}
								{sellingPrice > 0 && (
									<div
										className={`${
											printSetup[printSize].printMargin
										} flex items-center text-left ${
											printSize === "A4" ? "print-a4-section" : ""
										}`}>
										<div
											className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
											<div>
												<span
													className={`${printSetup[printSize].printTextSize}`}>
													TAGIHAN
												</span>
											</div>
											<div>
												<span
													className={`${printSetup[printSize].printTextSize}`}>
													:
												</span>
											</div>
										</div>
										<div className="flex-1">
											<NumberFormat
												value={sellingPrice}
												className={`${printSetup[printSize].printTextSize}`}
												displayType={"text"}
												thousandSeparator={"."}
												decimalSeparator={","}
												prefix={"Rp "}
											/>
										</div>
									</div>
								)}

								{/* ADMIN */}
								{sellingAdmin > 0 && (
									<div
										className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
										<div
											className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
											<div>
												<span
													className={`${printSetup[printSize].printTextSize}`}>
													ADMIN
												</span>
											</div>
											<div>
												<span
													className={`${printSetup[printSize].printTextSize}`}>
													:
												</span>
											</div>
										</div>
										<div className="flex-1">
											<NumberFormat
												value={sellingAdmin}
												className={`${printSetup[printSize].printTextSize}`}
												displayType={"text"}
												thousandSeparator={"."}
												decimalSeparator={","}
												prefix={"Rp "}
											/>
										</div>
									</div>
								)}
							</Fragment>
						)}

						{/* WHEN THERE IS A PRINT FIELD THEN SHOW THE LABEL */}
						{!print.length && (
							<>
								<Fragment>
									<div
										className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
										<div
											className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
											<div>
												<span
													className={`${`${printSetup[printSize].printTextSize}`}`}>
													SN
												</span>
											</div>
											<div>
												<span
													className={`${printSetup[printSize].printTextSize}`}>
													:
												</span>
											</div>
										</div>
										<div className="flex-1">
											<span
												className={`${printSetup[printSize].printTextSize} break-all whitespace-normal`}
												style={{
													fontSize: "10px",
													wordBreak: "break-all",
													whiteSpace: "normal",
													display: "block",
												}}>
												{sn.length > 14 ? sn.substring(0, 14) + "XXX" : sn}
											</span>
										</div>
									</div>
								</Fragment>

								{/* <Fragment>
                  <div className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
                    <div className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
                      <div>
                        <span className={`${`${printSetup[printSize].printTextSize}`}`}>HARGA</span>
                      </div>
                      <div>
                        <span className={`${printSetup[printSize].printTextSize}`}>:</span>
                      </div>
                    </div>
                    <div className="flex-1">
                    <NumberFormat
                      value={tagihan}
                      className={`${printSetup[printSize].printTextSize}`}
                      displayType={"text"}
                      thousandSeparator={"."}
                      decimalSeparator={","}
                      prefix={"Rp "}
                    />
                    </div>
                  </div>
                </Fragment> */}

								<Fragment>
									<div
										className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
										<div
											className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
											<div>
												<span
													className={`${`${printSetup[printSize].printTextSize}`}`}>
													ADMIN
												</span>
											</div>
											<div>
												<span
													className={`${printSetup[printSize].printTextSize}`}>
													:
												</span>
											</div>
										</div>
										<div className="flex-1">
											<NumberFormat
												value={sellingAdmin}
												className={`${printSetup[printSize].printTextSize}`}
												displayType={"text"}
												thousandSeparator={"."}
												decimalSeparator={","}
												prefix={"Rp "}
											/>
										</div>
									</div>
								</Fragment>
							</>
						)}
					</div>
				</div>
			</div>

			{printSize === "58mm" || printSize === "80mm" ? (
				<Fragment>
					{/* TOTAL PRICE */}
					<div
						className={`${printSetup[printSize].printMargin} flex justify-between items-center text-left mb-1 px-2`}>
						<div
							className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
							<div>
								<span className={`${printSetup[printSize].printTextSize}`}>
									TOTAL
								</span>
							</div>
							<div>
								<span className={`${printSetup[printSize].printTextSize}`}>
									:
								</span>
							</div>
						</div>
						<div className="flex-1">
							<NumberFormat
								value={tagihan + sellingAdmin}
								className={`${`${printSetup[printSize].printTextSize}`} font-bold`}
								displayType={"text"}
								thousandSeparator={"."}
								decimalSeparator={","}
								prefix={"Rp "}
							/>
						</div>
					</div>

					{/* JIKA PRINT 55MM & 85MM MUNCULKAN SN DI BAWAH */}
					{tokenSn && (
						<div className="px-2 mt-3 leading-3">
							<div className="flex-1 border border-dotted-2xl rounded-lg border-black p-2 bg-slate-200">
								<span
									className={`${printSetup[printSize].printTextSize} font-bold`}>
									{tokenSn}
								</span>
							</div>
						</div>
					)}

					{footer_text ? (
						<div className="px-2 mt-3 leading-3">
							<span
								className={`${`${printSetup[printSize].printTextSize}`} font-bold`}>
								{footer_text}
							</span>
						</div>
					) : (
						<Fragment>
							<div className="px-2 mt-3 leading-3">
								<span
									className={`${`${printSetup[printSize].printTextSize}`} font-bold`}>
									STRUK INI ADALAH BUKTI PEMBAYARAN YANG SAH
								</span>
							</div>
							<div className="px-2 mt-1 leading-3">
								<span className={`${printSetup[printSize].printTextSize}`}>
									Tersedia juga Pulsa, Game, Produk Pascabayar dan Produk
									Lainnya
								</span>
							</div>
						</Fragment>
					)}
				</Fragment>
			) : (
				<Fragment>
					{/* A4 Layout - Total and Footer */}
					<div
						className={`${
							printSize === "A4"
								? "mt-6 flex justify-center"
								: "flex justify-center mt-4"
						}`}>
						{tokenSn && (
							<div
								className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
								<div
									className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
									<div>
										<span className={`${printSetup[printSize].printTextSize}`}>
											TOKEN
										</span>
									</div>
									<div>
										<span className={`${printSetup[printSize].printTextSize}`}>
											:
										</span>
									</div>
								</div>
								<div className="flex-1">
									<span className={`${printSetup[printSize].printTextSize}`}>
										{tokenSn}
									</span>
								</div>
							</div>
						)}

						{print.length > 6 && (
							<>
								{sellingPrice > 0 && (
									<div
										className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
										<div
											className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
											<div>
												<span
													className={`${printSetup[printSize].printTextSize}`}>
													TAGIHAN
												</span>
											</div>
											<div>
												<span
													className={`${printSetup[printSize].printTextSize}`}>
													:
												</span>
											</div>
										</div>
										<div className="flex-1">
											<NumberFormat
												value={sellingPrice}
												className={`${printSetup[printSize].printTextSize}`}
												displayType={"text"}
												thousandSeparator={"."}
												decimalSeparator={","}
												prefix={"Rp "}
											/>
										</div>
									</div>
								)}

								{/* ADMIN */}
								{sellingAdmin > 0 && (
									<div
										className={`${printSetup[printSize].printMargin} flex items-center text-left`}>
										<div
											className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
											<div>
												<span
													className={`${printSetup[printSize].printTextSize}`}>
													ADMIN
												</span>
											</div>
											<div>
												<span
													className={`${printSetup[printSize].printTextSize}`}>
													:
												</span>
											</div>
										</div>
										<div className="flex-1">
											<NumberFormat
												value={sellingAdmin}
												className={`${printSetup[printSize].printTextSize}`}
												displayType={"text"}
												thousandSeparator={"."}
												decimalSeparator={","}
												prefix={"Rp "}
											/>
										</div>
									</div>
								)}
							</>
						)}

						{/* TOTAL PRICE */}
						<div
							className={`${
								printSetup[printSize].printMargin
							} flex justify-between items-center text-left mb-1 ${
								printSize === "A4" ? "print-total" : "text-center"
							}`}>
							<div
								className={`flex justify-between ${printSetup[printSize].printWhiteSpace}`}>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										TOTAL
									</span>
								</div>
								<div>
									<span className={`${printSetup[printSize].printTextSize}`}>
										:
									</span>
								</div>
							</div>
							<div className="flex-1">
								<NumberFormat
									value={tagihan + sellingAdmin}
									className={`${`${printSetup[printSize].printTextSize}`} font-bold`}
									displayType={"text"}
									thousandSeparator={"."}
									decimalSeparator={","}
									prefix={"Rp "}
								/>
							</div>
						</div>
					</div>

					{footer_text ? (
						<div
							className={`px-2 mt-3 leading-3 ${
								printSize === "A4" ? "print-footer" : ""
							}`}>
							<span
								className={`${`${printSetup[printSize].printTextSize}`} font-bold`}>
								{footer_text}
							</span>
						</div>
					) : (
						<Fragment>
							<div
								className={`px-2 mt-4 leading-3 ${
									printSize === "A4" ? "print-footer" : ""
								}`}>
								<span
									className={`${`${printSetup[printSize].printTextSize}`} font-bold`}>
									STRUK INI ADALAH BUKTI PEMBAYARAN YANG SAH
								</span>
							</div>
							<div
								className={`px-2 mt-1 leading-3 ${
									printSize === "A4" ? "print-footer" : ""
								}`}>
								<span
									className={`${printSize === "A4" ? "text-sm" : "text-xs"}`}>
									Tersedia juga Pulsa, Game, Produk Pascabayar dan Produk
									Lainnya
								</span>
							</div>
						</Fragment>
					)}
				</Fragment>
			)}
		</Fragment>
	);
};

export { DefaultContent, PlnContent, SpeedyContent, BpjsContent, PDAMContent };
